export default __webpack_public_path__ + "static/media/Garlic mustard.a6476f9b.jpg";